import React, { useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Collection, Button } from '@components/common';
import { useLanguage } from '@contexts/LanguageContext';
import { useCategoryCreationPermission } from '@hooks/useCategoryPermissions';
import Icon from '@components/Icon/Icon';
import './CategoriesPage.scss';

const CategoriesPage = () => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const { canCreate: canCreateCategory } = useCategoryCreationPermission();

    const openCreatePage = useCallback(() => {
        navigate('/categories/create');
    }, [navigate]);

    const handleRefresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
    }, []);

    return (
        <div className="categories-page">
            <Collection
                modelName="categories"
                displayType="list"
                title={t('categories.title')}
                description={t('categories.subtitle')}
                className="categories-collection"
                refreshTrigger={refreshTrigger}
                enableSearch={true}
                enablePagination={true}
                onRefresh={handleRefresh}
            />
        </div>

    );
};

export default CategoriesPage;
